import { isSameObject, isObject, isEmpty } from './util';

import createElement from './CreateElement';

import scanTree from './ScanTree';

let _createElement;

function sameInputType(a, b) {    
    if (a.tag !== 'input') return true
    var i;    
    var types = [
        'text','number','password',
        'search','email','tel','url'
    ]    
    var typeA = (i = a.data) && (i = i.attrs) && i.type;    
    var typeB = (i = b.data) && (i = i.attrs) && i.type;    
    // input 的类型一样，或者都属于基本input类型
    return (
        typeA === typeB ||
        types.indexOf(typeA)>-1 &&
        types.indexOf(typeB)>-1
    )
}

function sameVnode (a, b) {
    return (
      (isObject(a) &&  isObject(b)) && a.key === b.key &&
      a.tagName === b.tagName &&
      isSameObject(a.data, b.data) && sameInputType(a, b)
    //   && sameInputType(a, b)
    )
}

function isNeedUpdate(a, b) {
    let result = false;
    if (a.className !== b.className) {
        return true;
    }
    if (a.is_show !== b.is_show) {
        return true;
    }
    if (a.inner_html !== b.inner_html) {
        return true;
    }
    switch(a.tagName) {
        case 'text':
            if (a.text !== b.text) {
                result = true;
            }
            break;
        case 'img':
            if (a.src !== b.src) {
                return true;
            }
            break;
        default:
            if (a.is_component) {
                let a_data = a.v_item;
                let b_data = b.v_item;
                if (a.component && a.component._vm_data) {
                    a_data = {...a.v_item, ...a.component._vm_data }
                }
                if (b.component && b.component._vm_data) {
                    b_data = {...b.v_item, ...b.component._vm_data }
                }
                result = !isSameObject(a_data, b_data)
            }
            break;
    }
    return result;
}

function updateSameVnode(a, b) {
    if (a.el) {
        if (a.className !== b.className) {
            a.el.setAttribute('class', b.className);
        }
        if (a.is_show !== b.is_show && a.el.style) {
            a.el.style.display = (b.is_show === false ? 'none' : '');
        }
        if (a.inner_html !== b.inner_html) {
            a.el.innerHTML = b.inner_html;
        }
        switch(a.tagName) {
            case 'text':
                a.el.textContent = b.text || '';
                break;
            case 'img':
                a.el.setAttribute('src', b.src);
                break;
            default:
                if (a.is_component) {
                    a.v_item = b.v_item;
                    if (isObject(a.v_item) && a.component) {
                        if (a.component && a.component._vm_data) {
                            a_data = {...a.v_item, ...a.component._vm_data };
                            a.component.setData(a_data, true);
                        } else {
                            a.component.setData(a.v_item, true);
                        }
                    }
                }
                break;
        }
    }
}

function patchSameVnode (oldNode, newNode, result) {
    let self = this;
    if (result) {
        let oldEl = oldNode.el;
        newNode.el = oldEl;
        if (isNeedUpdate(oldNode, newNode)) {
            updateSameVnode(oldNode, newNode);
        }
        let old_children = oldNode.children || [];
        let new_children = newNode.children || [];
        if (old_children.length && new_children.length) {
            patchChildrenVnode.call(self, oldNode, newNode, result);
        } else if (old_children.length || new_children.length){
            if (!old_children.length) {
                for(let child of new_children) {
                    _createElement(child);
                    if (child && child.el) {
                        newNode.el.appendChild(child.el);
                    }
                }
            }
            if (!new_children.length) {
                for(let child of old_children) {
                    if (child && child.el) {
                        $(child.el).remove();
                    }
                    if (child && child.key && self._children) {
                        self._children[child.key] = undefined;
                        delete self._children[child.key];
                    }
                }
            }
        }
    }
}

function insertBefore (parentElm, newEl, nextEl) {
    if (parentElm && newEl) {
        parentElm.insertBefore(newEl, nextEl);
    }
}

function nextSibling (el) {
    if (el) {
        return el.nextSibling;
    }
}

function createElm (newStartVnode, result, parentElm, oldStartVnodeEl, input, new_children, newStartIdx) {
    if (parentElm && oldStartVnodeEl) {
        _createElement(newStartVnode);
        if (newStartVnode.el) {
            parentElm.insertBefore(newStartVnode.el, oldStartVnodeEl);
            let grand_children = newStartVnode.children || [];
            for(let grand_child of grand_children) {
                scanTree(grand_child, function (vnode) {
                    _createElement(vnode);
                    if (vnode.el && vnode.parentVnode && vnode.parentVnode.el) {
                        vnode.parentVnode.el.appendChild(vnode.el);
                    }
                    return true;
                })
            }
        }
    }
}

function isDef (val) {
    return val !== undefined && val !== null;
}

function isUndef (val) {
    return val === undefined;
}

function findIdxInOld (node, children, start, end) {
    if (isUndef(node.key)) {
        return;
    }
    let result;
    for(let index = start;index <= end;index++) {
        if (children[index] && isDef(children[index].key) && node.key === children[index].key) {
            result = index;
            break;
        }
    }
    return result;
}

function createKeyToOldIdx (children, start, end) {
    let map = {};
    for(let index = start;index <= end;index++) {
        if (children[index] && isDef(children[index].key)) {
            map[children[index].key] = index;
        }
    }
    return map;
}

function addVnodes (parentElm, refElm, new_children, newStartIdx, newEndIdx, result) {
    if (parentElm && (newStartIdx <= newEndIdx)) {
        for(let idx = newStartIdx;idx <= newEndIdx;idx++) {
            if (new_children[idx]) {
                if (!new_children[idx].el) {
                    _createElement(new_children[idx]);
                }
                if (new_children[idx].el) {
                    parentElm.insertBefore(new_children[idx].el, refElm);
                }
                let grand_children = new_children[idx].children || [];
                for(let grand_child of grand_children) {
                    scanTree(grand_child, function (vnode) {
                        _createElement(vnode);
                        if (vnode.el && vnode.parentVnode && vnode.parentVnode.el) {
                            vnode.parentVnode.el.appendChild(vnode.el);
                        }
                        return true;
                    })
                }
            }
        }
    }
}

function removeVnodes (old_children, oldStartIdx, oldEndIdx) {
    let self = this;
    if (oldStartIdx <= oldEndIdx) {
        for(let idx = oldStartIdx;idx <= oldEndIdx;idx++) {
            if (old_children[idx] && old_children[idx].el) {
                $(old_children[idx] && old_children[idx].el).remove();
            }
            if (old_children[idx] && old_children[idx].key && self._children) {
                self._children[old_children[idx].key] = undefined;
                delete self._children[old_children[idx].key];
            }
        }
    }
}


function patchChildrenVnode (oldNode, newNode, result) {
    let self = this;
    let old_children = oldNode.children || [];
    let new_children = newNode.children || [];
    let oldStartIndex = 0;
    let newStartIndex = 0;
    for(let child of old_children) {
        child.index = oldStartIndex;
        oldStartIndex++;
    }
    for(let child of new_children) {
        child.index = newStartIndex;
        newStartIndex++;
    }
    let oldStartIdx = 0 // 旧节点开始下标
    let newStartIdx = 0 // 新节点开始下标
    let oldEndIdx = old_children.length - 1 // 旧节点结束下标
    let oldStartVnode = old_children[0]  // 旧节点开始vnode
    let oldEndVnode = old_children[oldEndIdx] // 旧节点结束vnode
    let newEndIdx = new_children.length - 1 // 新节点结束下标
    let newStartVnode = new_children[0] // 新节点开始vnode
    let newEndVnode = new_children[newEndIdx] // 新节点结束vnode
    let canMove = true;
    let parentElm = newNode.el;
    let needConsole = false;
    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
        //处理逻辑
        if (isEmpty(oldStartVnode)) {   // 对于vnode.key的比较，会把oldVnode = null
            oldStartVnode = old_children[++oldStartIdx];
        } else if (isEmpty(oldEndVnode)) {
            oldEndVnode = old_children[--oldEndIdx];
        } else if (isEmpty(newStartVnode)) {
            newStartVnode = new_children[++newStartIdx];
        } else if (isEmpty(newEndVnode)) {
            newEndVnode = new_children[--newEndIdx];
        } else if (sameVnode(oldStartVnode, newStartVnode)) {
            patchSameVnode.call(self, oldStartVnode, newStartVnode, result, new_children, newStartIdx);
            oldStartVnode = old_children[++oldStartIdx]
            newStartVnode = new_children[++newStartIdx]
        } else if (sameVnode(oldEndVnode, newEndVnode)) {
            patchSameVnode.call(self, oldEndVnode, newEndVnode, result, new_children, newEndIdx);
            oldEndVnode = old_children[--oldEndIdx]
            newEndVnode = new_children[--newEndIdx]
        } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
            patchSameVnode.call(self, oldStartVnode, newEndVnode, result, new_children, newEndIdx);
            canMove && insertBefore(parentElm, oldStartVnode.el, nextSibling(oldEndVnode.el))
            oldStartVnode = old_children[++oldStartIdx]
            newEndVnode = new_children[--newEndIdx]
        } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
            patchSameVnode.call(self, oldEndVnode, newStartVnode, result, new_children, newStartIdx);
            canMove && insertBefore(parentElm, oldEndVnode.el, oldStartVnode.el)
            oldEndVnode = old_children[--oldEndIdx]
            newStartVnode = new_children[++newStartIdx]
        }else {// 没有找到相同的可以复用的节点，则新建节点处理
            let oldKeyToIdx = old_children.oldKeyToIdx;
            /* 生成一个key与旧VNode的key对应的哈希表（只有第一次进来undefined的时候会生成，也为后面检测重复的key值做铺垫） 比如childre是这样的 [{xx: xx, key: 'key0'}, {xx: xx, key: 'key1'}, {xx: xx, key: 'key2'}] beginIdx = 0 endIdx = 2 结果生成{key0: 0, key1: 1, key2: 2} */
            if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(old_children, oldStartIdx, oldEndIdx)
            /*如果newStartVnode新的VNode节点存在key并且这个key在oldVnode中能找到则返回这个节点的idxInOld（即第几个节点，下标）*/
            let idxInOld = isDef(newStartVnode.key)
              ? oldKeyToIdx[newStartVnode.key]
              : findIdxInOld(newStartVnode, old_children, oldStartIdx, oldEndIdx)
            if (isUndef(idxInOld)) { // New element
              /*newStartVnode没有key或者是该key没有在老节点中找到则创建一个新的节点*/
              createElm(newStartVnode, result, parentElm, oldStartVnode.el, false, new_children, newStartIdx)
            } else {
              /*获取同key的老节点*/
              let vnodeToMove = old_children[idxInOld]
              if (sameVnode(vnodeToMove, newStartVnode)) {
                /*如果新VNode与得到的有相同key的节点是同一个VNode则进行patchVnode*/
                patchSameVnode.call(self, vnodeToMove, newStartVnode, result, new_children, newStartIdx)
                //因为已经patchVnode进去了，所以将这个老节点赋值undefined
                let vnode_to_move_el = vnodeToMove.el;
                old_children[idxInOld] = undefined
                /*当有标识位canMove实可以直接插入oldStartVnode对应的真实Dom节点前面*/
                canMove && insertBefore(parentElm, vnode_to_move_el, oldStartVnode.el)
              } else {
                // same key but different element. treat as new element
                /*当新的VNode与找到的同样key的VNode不是sameVNode的时候（比如说tag不一样或者是有不一样type的input标签），创建一个新的节点*/
                createElm(newStartVnode, result, parentElm, oldStartVnode.el, false, new_children, newStartIdx)
              }
            }
            newStartVnode = new_children[++newStartIdx]
        }    
    }
    if (oldStartIdx > oldEndIdx) {
        /*全部比较完成以后，发现oldStartIdx > oldEndIdx的话，说明老节点已经遍历完了，新节点比老节点多， 所以这时候多出来的新节点需要一个一个创建出来加入到真实Dom中*/
        let refElm = isUndef(new_children[newEndIdx + 1]) ? null : new_children[newEndIdx + 1].el
        addVnodes(parentElm, refElm, new_children, newStartIdx, newEndIdx, result) //创建 newStartIdx - newEndIdx 之间的所有节点
    } else if (newStartIdx > newEndIdx) {
        /*如果全部比较完成以后发现newStartIdx > newEndIdx，则说明新节点已经遍历完了，老节点多于新节点，这个时候需要将多余的老节点从真实Dom中移除*/
        removeVnodes.call(self,old_children, oldStartIdx, oldEndIdx) //移除 oldStartIdx - oldEndIdx 之间的所有节点
    }
}

export default function treePatch(oldTree, newTree, components) {
    let self = this;
    _createElement = createElement.bind({
        components: components || {},
        _children: self._children || {}
    });
    let result = {
        replaceFullTree: false,
        insertsQueue: [],
        removeQueue: [],
        updateQueue: []
    }
    if (sameVnode(oldTree, newTree)) {
        patchSameVnode.call(self, oldTree, newTree, result);
    } else {
        result.replaceFullTree = true
    }
    return result;
}